var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"container-lg",attrs:{"id":"rs-header"}},[_c('div',{staticClass:"d-flex flex-row align-items-center mb-2 pt-2"},[_c('div',{staticClass:"mr-auto"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"logotop",attrs:{"src":"assets/images/header-logo.png","alt":""}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }